<template>
  <div class="container-fluid mt-4 Kitchen">
    <b-row>
      <b-col cols="12" md="10" order="2" order-md="1">
        <b-row class="mx-auto text-center">
          <b-col
            cols="3"
            md="2"
            class="noselect px-1 table-link"
            v-for="(Order, OrderIndex) in Orders"
            :key="OrderIndex"
          >
            <audio :autoplay="AutoPlay" v-if="false">
              <source :src="require('@/assets/sounds/Doorbell.wav')" />
            </audio>

            <a
              href="#"
              @click.prevent="() => { if (Order.LastProcess.TypeID !== 2) AddProcess(Order.ID, 2); else return false; }"
              :class="`d-block order border-0 btn btn-huge btn-warning${(Order.LastProcess.TypeID === 2) ? ' finished' : ''}`"
              v-if="Order.LastProcess.TypeID !== 2"
            >
              <span class="table-name">
                <b-btn :size="ButtonSize" class="btn-light d-block m-0 p-0 py-0 ws-nowrap">
                  <b-row class="m-0">
                    <b-col cols="6" class="p-0 m-0">
                      <span class="total-price text-clock mr-2">{{ Order.Saat }}</span>
                    </b-col>

                    <b-col cols="6" class="p-0 m-0">{{ Order.Masa }}</b-col>
                  </b-row>
                </b-btn>

                <span
                  class="badge badge-pill badge-info rounded order-quantity"
                  v-if="Order.Adet !== 1"
                >{{ Order.Adet }} Adet</span>

                <span
                  :class="`${Order.Adet !== 1 ? '' : 'mt-1'} d-block`"
                >{{ `${Order.Ürün}${Order.Adet !== 1 ? '' : ''}` }}</span>

                <span class="total-price">
                  <span
                    class="d-block"
                    v-for="(Extra, ExtraIndex) in Order.Secenekler"
                    :key="ExtraIndex"
                  >+ {{ Extra.Name }}</span>
                </span>
              </span>
            </a>
          </b-col>
        </b-row>
      </b-col>

      <b-col order="1" order-md="2">
        <a
          href="#"
          @click.prevent="() => false"
          class="btn d-block btn-warning text-left mb-2 pl-2 align-items-center"
          v-if="Object.keys(Quantities).length === 0"
        >Bekleyen Sipariş Yok</a>

        <a
          href="#"
          @click.prevent="() => false"
          :class="`btn d-block btn-warning text-left mb-2 pl-2 align-items-center`"
          v-for="(Product, Index) in Quantities"
          :key="Index"
        >
          <span class="table-name mb-3">{{ Product.Quantity }} Adet {{ Product.Name }}</span>

          <span class="table-name d-block" v-if="Product.HasSpecExtra">
            <span
              class="d-block"
              v-for="(Extra, ExtraIndex) in Product.Order.Extras"
              :key="ExtraIndex"
            >+ {{ Extra.Name }}</span>
          </span>
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../Service";
import datetr from "@/Date";

export default {
  data() {
    return {
      Enums: {
        ProcessTypes: {
          1: "warning",
          2: "success"
        }
      },
      Orders: [],
      Quantities: {},
      AutoPlay: false
    };
  },
  created() {
    setTimeout(async () => {
      await this.$set(this, "AutoPlay", true);
    }, 2000);
  },
  computed: {
    ...mapState(["StoreData", "ButtonSize"])
  },
  methods: {
    date: (timestamp, format = "dd.mm.yyyy") => {
      return datetr(timestamp, format);
    },
    async UpdateOrders() {
      let _Orders = [];
      let _Quantities = {};

      let Places = (await this.StoreData.Places)
        ? await this.StoreData.Places
        : {};

      for (let i in Places) {
        let Place = Places[i];
        let Tables = Place.Tables ? Place.Tables : {};

        for (let n in Tables) {
          let Table = Tables[n];

          if (Table.Session && Table.Session.Status === 1) {
            let Orders = Table.Session.Orders ? Table.Session.Orders : {};

            for (let o in Orders) {
              let Order = Orders[o];

              Order.KitchenID = this.StoreData.Products[
                Order.ProductID
              ].KitchenID;

              Order.KitchenName = this.StoreData.Kitchens[Order.KitchenID].Name;

              if (Order.KitchenName === "Mutfak Dışı") continue;

              _Orders.push({
                ID: Order.LastProcess.TypeID !== 2 ? Order.ID : Order.ID + 9999,
                Saat: this.date(Order.Time, "HH:MM"),
                Garson: this.StoreData.Staff[Order.WaiterID].Name,
                Ürün: this.StoreData.Products[Order.ProductID].Name,
                Secenekler: Order.Extras ? Order.Extras : {},
                Adet: Order.Portion,
                Masa: Table.Name,
                LastProcess: Order.LastProcess,
                Durumu: `${Order.LastProcess.TypeName}${
                  Order.LastProcess.Description !== "" ? ": " : ""
                }${Order.LastProcess.Description}`
              });

              if (Order.LastProcess.TypeID !== 2) {
                if (Order.Extras && Object.keys(Order.Extras).length > 0)
                  for (let e in Order.Extras) {
                    let _Extra = Order.Extras[e];

                    if (["Ek Ürün", "Porsiyon"].indexOf(_Extra.TypeName) !== -1)
                      Order.HasSpecExtra = true;
                  }

                if (Order.HasSpecExtra !== undefined) {
                  _Quantities["Order" + Order.ID] = {
                    Name: this.StoreData.Products[Order.ProductID].Name,
                    Quantity: Order.Portion,
                    Order,
                    HasSpecExtra: true
                  };
                } else {
                  if (!_Quantities[Order.ProductID])
                    _Quantities[Order.ProductID] = {
                      Name: this.StoreData.Products[Order.ProductID].Name,
                      Quantity: 0,
                      HasSpecExtra: false
                    };

                  _Quantities[Order.ProductID].Quantity += Order.Portion;
                }
              }
            }
          }
        }
      }

      await this.$set(
        this,
        "Orders",
        _Orders.sort((a, b) => (a.ID < b.ID ? -1 : a.ID > b.ID ? 1 : 0))
      );

      await this.$set(this, "Quantities", _Quantities);
    },
    async AddProcess(OrderID, TypeID) {
      this.$store.dispatch("AddLoading", "AddProcess");

      await Services.Nozich.Send(
        "AddProcess",
        {
          OrderID,
          TypeID
        },
        async () => {
          await this.$store.dispatch("RemoveLoading", "AddProcess");
        }
      );
    }
  },
  async mounted() {
    await this.UpdateOrders();

    this.$store.subscribe(async mutation => {
      await this.$nextTick();
      await this.$forceUpdate();

      if (["Up", "Del"].indexOf(mutation.type) !== -1) {
        await this.UpdateOrders();
      }
    });
  }
};
</script>
